import { Plus, Trash2 } from 'lucide-react'
import { Button, Input } from '@/components/ui'
import type { TimelineEvent } from '../api/types'

interface Props {
  items: TimelineEvent[]
  onChange: (items: TimelineEvent[]) => void
  readOnly?: boolean
}

function blankRow(): TimelineEvent {
  return { when: '', event: '', result: '' }
}

export function TimelineEventsEditor({ items, onChange, readOnly = false }: Props) {
  const rows = items.length > 0 ? items : [blankRow()]

  function update(idx: number, field: keyof TimelineEvent, value: string) {
    onChange(rows.map((row, i) => (i === idx ? { ...row, [field]: value } : row)))
  }

  function addRow() {
    onChange([...rows, blankRow()])
  }

  function removeRow(idx: number) {
    if (rows.length === 1) {
      onChange([blankRow()])
    } else {
      onChange(rows.filter((_, i) => i !== idx))
    }
  }

  return (
    <div className="space-y-2">
      <div className="grid grid-cols-[1fr_2fr_1.4fr_36px] gap-2 px-1">
        {['Date / Time', 'Event', 'Status / Result', ''].map((h) => (
          <span key={h} className="text-xs font-medium text-secondary uppercase tracking-wide">
            {h}
          </span>
        ))}
      </div>
      {rows.map((row, idx) => (
        <div key={idx} className="grid grid-cols-[1fr_2fr_1.4fr_36px] gap-2 items-start">
          <Input value={row.when ?? ''} onChange={(e) => update(idx, 'when', e.target.value)} placeholder="e.g. June 17, 2026" disabled={readOnly} />
          <Input value={row.event ?? ''} onChange={(e) => update(idx, 'event', e.target.value)} placeholder="What happened" disabled={readOnly} />
          <Input value={row.result ?? ''} onChange={(e) => update(idx, 'result', e.target.value)} placeholder="Status / result" disabled={readOnly} />
          {!readOnly ? (
            <button
              type="button"
              onClick={() => removeRow(idx)}
              className="h-8 w-8 flex items-center justify-center rounded text-secondary hover:text-danger hover:bg-danger/10 transition-colors"
              title="Remove event"
            >
              <Trash2 size={14} />
            </button>
          ) : (
            <div />
          )}
        </div>
      ))}
      {!readOnly && (
        <Button variant="ghost" size="sm" onClick={addRow} className="mt-1">
          <Plus size={14} className="mr-1" /> Add event
        </Button>
      )}
    </div>
  )
}
